import { toast } from 'vue-sonner'

import i18n from '@/lang/'

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}

// Helper to avoid vue-i18n type instantiation depth limit
const t = (key: string): string => (i18n.global as any).t(key)

export const copyTextToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
  }

  navigator.clipboard.writeText(text).then(
    () => {
      console.log('Async: Copying to clipboard was successful!')
      toast.success(t('generic.copiedContent'))
    },
    err => {
      console.error('Async: Could not copy text: ', err)
      toast.error(t('generic.copyFailed'))
    },
  )
}
